import React, {Component} from 'react';
import styles from "./termreport.module.css";
import back from '../../img/ic_back.png';
import caiji from '../../img/ic_caiji.png';

import BadgeSmall from '../termreport/badge/badgeSmall.jsx';
import BadgeLarge from '../termreport/badge/badgeLarge.jsx';
import PieChart1 from '../termreport/piechart1/pieChart1.jsx';
import PieChart2 from '../termreport/piechart2/pieChart2.jsx';
import BarChart1 from '../termreport/barchart1/barChart1.jsx';
import BarChart2 from '../termreport/barchart2/barChart2.jsx';
import LineChart1 from '../termreport/linechart1/lineChart1.jsx';
import LineChart2 from '../termreport/linechart2/lineChart2.jsx';
import Xueyuan from '../termreport/xueyuan/xueyuan.jsx';
import PieChart11 from '../termreport/piechart1/pieChart11.jsx';
import PieChart22 from '../termreport/piechart2/pieChart22.jsx';
import BarChart11 from '../termreport/barchart1/barChart11.jsx';
import BarChart22 from '../termreport/barchart2/barChart22.jsx';
import LineChart11 from '../termreport/linechart1/lineChart11.jsx';
import LineChart22 from '../termreport/linechart2/lineChart22.jsx';

import BadgeRanking from '../studentinfo/badgeRanking/badgeRanking.jsx';
import DianzanRanking from '../studentinfo/dianzanRanking/dianzanRanking.jsx';
import FaceCollect from '../studentinfo/faceCollect/faceCollect.jsx';

import bg1 from '../../img/bg1.png';
import bg2 from '../../img/bg7.png';
import bg3 from '../../img/bg3.png';
import bg4 from '../../img/bg_xiaoxun.png';
import bg5 from '../../img/bg5.png';
import bg6 from '../../img/bg6.png';
import logo from '../../img/ic_report_logo.png';
import ic_pingyu from '../../img/ic_pingyu.png'

import pet1 from '../../img/ic_pet1.png';
import pet2 from '../../img/ic_pet2.png';
import pet3 from '../../img/ic_pet3.png';
import pet4 from '../../img/ic_pet4.png';
import pet5 from '../../img/ic_pet5.png';
import pet6 from '../../img/ic_pet6.png';

import ic_xiaoxun from '../../img/ic_xiaoxun.png';
import ic_xiaofeng from '../../img/ic_xiaofeng.png';
import ic_xuefeng from '../../img/ic_xuefeng.png';
import ic_jiaofeng from '../../img/ic_jiaofeng.png';

import icLoading from '../../img/ic_loading.png';


import HTMLFlipBook from "react-pageflip";


const PageCover = React.forwardRef((props, ref) => {
    return (
        <div className={styles["page-cover"]} ref={ref} data-density="hard">
            <div className="page-content">
                <h2>{props.children}</h2>
            </div>
        </div>
    );
});


const Studentinfo = props => (

    <div className={styles.root}>

        <div className={styles.menubar}>
            <img className={styles["img-back"]} src={back} onClick={props.closeStudentinfoModal}/>
            <div className={styles["modal-title"]}>{sessionStorage.getItem('studentname')}的学期报告</div>
            <div className={styles["div-caiji"]} onClick={props.openFaceCollectPrompt}>
                <div>生成报告</div>
            </div>
        </div>

        {props.showLoading ?
            <div className={styles["div-loading"]}>
                <img className={styles["img-loading"]} src={icLoading}/>
                <div>{props.loadingResult}</div>
            </div>
            : null}

        <div className={styles.container2} >
        <HTMLFlipBook

            type='soft'
            // size="stretch"
            size="fixed"
            // width={620}
            // height={890}
            width={434}
            height={623}
            // minWidth={434}
            // maxWidth={434}
            // minHeight={623}
            // maxHeight={623}
            autoSize={true}
            showCover={true}

            // flippingTime={1000}
            maxShadowOpacity={0.5} //阴影强度（1：最大强度，0：隐藏阴影）
            drawShadow={false} //翻页时是否绘制阴影true
            className={styles.book}
        >

            <div className={styles["bg-item2"]} id='header2'>
                <div className={styles.header}>
                    <img className={styles.bg1} src={bg1}/>
                    <div className={styles["report-shouye"]}>
                        <div className={styles["shouye-item"]}>
                            <div className={styles["shouye-item-title"]}>学校：</div>
                            <div className={styles["shouye-item-line"]}>{sessionStorage.getItem('schoolname')}</div>
                        </div>
                        <div className={styles["shouye-item"]}>
                            <div className={styles["shouye-item-title"]}>班级：</div>
                            <div className={styles["shouye-item-line"]}>{sessionStorage.getItem('reportBanji')}</div>
                        </div>
                        <div className={styles["shouye-item"]}>
                            <div className={styles["shouye-item-title"]}>姓名：</div>
                            <div className={styles["shouye-item-line"]}>{sessionStorage.getItem('studentname')}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles["bg-item2"]} id='xiaoxun2'>
                <div className={styles.header}>
                    <img className={styles.bg1} src={bg4}/>
                    <div className={styles["report-xiaoxun"]}>
                        <img className={styles["img-xiaoxun"]} src={ic_xiaoxun}/>
                        <img className={styles["img-xiaoxun"]} src={ic_xiaofeng}/>
                        <img className={styles["img-xiaoxun"]} src={ic_jiaofeng}/>
                        <img className={styles["img-xiaoxun"]} src={ic_xuefeng}/>
                    </div>
                </div>
            </div>

            <div className={styles["bg-item2"]} id='xueyuan2'>
                <div className={styles.header}>
                    <img className={styles.bg1} src={bg2}/>
                    <img className={styles["img-pet3"]} src={pet5}/>
                    <Xueyuan/>
                </div>
            </div>

            <div className={styles["bg-item2"]} id='badge2'>
                <div className={styles.header}>
                    <img className={styles.bg1} src={bg2}/>
                    <img className={styles["img-pet2"]} src={pet1}/>
                    <div className={styles["container-fengchao"]}>
                        {props.yemian == '1' ?
                            <BadgeSmall
                                jihao={props.jihao}
                                hzsum={props.hzsum}/> :
                            null
                        }
                        {props.yemian == '2' ?
                            <BadgeLarge
                                jihao={props.jihao}
                                hzsum={props.hzsum}/> :
                            null
                        }
                    </div>
                </div>
            </div>

            <div className={styles["bg-item2"]} id='paiming2'>
                <div className={styles.header}>
                    <img className={styles.bg1} src={bg3}/>
                    <img className={styles["img-pet1"]} src={pet3}/>
                    <div className={styles["container-fengchao"]}>
                        <img className={styles["img-logo"]} src={logo}/>
                        <BarChart1
                            hzDzRankingData={props.hzDzRankingData}/>
                        <BarChart2/>
                    </div>
                </div>
            </div>

            <div className={styles["bg-item2"]} id='hzdz2'>
                <div className={styles.header}>
                    <div className={styles["container-fengchao"]}>
                        <img className={styles["img-logo"]} src={logo}/>
                        <PieChart1/>
                        <PieChart2/>
                    </div>
                    <img className={styles.bg1} src={bg2}/>
                    <img className={styles["img-pet2"]} src={pet2}/>
                </div>
            </div>

            <div className={styles["bg-item2"]} id='quxian2'>
                <div className={styles.header}>
                    <img className={styles.bg1} src={bg3}/>
                    <div className={styles["container-fengchao"]}>
                        <div className={styles["text-blue"]}>学期表现曲线</div>
                        <LineChart1/>
                        <LineChart2/>
                    </div>
                    <img className={styles["img-pet1"]} src={pet4}/>
                </div>
            </div>

            <div className={styles["bg-item2"]} id='pingyu2'>
                <div className={styles.header}>
                    <img className={styles.bg1} src={bg2}/>
                    <div className={styles["container-pingyu"]}>
                        <img className={styles["img-pingyu"]} src={ic_pingyu}/>
                        <div className={styles["div-pingyu"]}>{props.pingyu}</div>
                    </div>
                    <img className={styles["img-pet1"]} src={pet6}/>
                </div>
            </div>

        </HTMLFlipBook>
        </div>

          <div className={styles.container} id='report'>

            <div className={styles["bg-item"]} id='header'>
                <img className={styles.bg1} src={bg1}/>
                <div className={styles["report-shouye"]}>
                    <div className={styles["shouye-item"]}>
                        <div className={styles["shouye-item-title"]}>学校：</div>
                        <div className={styles["shouye-item-line"]}>{sessionStorage.getItem('schoolname')}</div>
                    </div>
                    <div className={styles["shouye-item"]}>
                        <div className={styles["shouye-item-title"]}>班级：</div>
                        <div className={styles["shouye-item-line"]}>{sessionStorage.getItem('reportBanji')}</div>
                    </div>
                    <div className={styles["shouye-item"]}>
                        <div className={styles["shouye-item-title"]}>姓名：</div>
                        <div className={styles["shouye-item-line"]}>{sessionStorage.getItem('studentname')}</div>
                    </div>
                </div>
            </div>

            <div className={styles["bg-item"]} id='xiaoxun'>
                <img className={styles.bg1} src={bg4}/>
                <div className={styles["report-xiaoxun"]}>
                    <img className={styles["img-xiaoxun"]} src={ic_xiaoxun}/>
                    <img className={styles["img-xiaoxun"]} src={ic_xiaofeng}/>
                    <img className={styles["img-xiaoxun"]} src={ic_jiaofeng}/>
                    <img className={styles["img-xiaoxun"]} src={ic_xuefeng}/>
                </div>

            </div>

            <div className={styles["bg-item"]} id='xueyuan'>
                <img className={styles.bg1} src={bg2}/>
                <img className={styles["img-pet2"]} src={pet5}/>
                <Xueyuan/>
            </div>

            <div className={styles["bg-item"]} id='badge'>
                <img className={styles.bg1} src={bg2}/>
                <img className={styles["img-pet1"]} src={pet1}/>

                <div className={styles["container-fengchao"]}>
                    {props.yemian == '1' ?
                        <BadgeSmall
                            jihao={props.jihao}
                            hzsum={props.hzsum}/> :
                        null
                    }
                    {props.yemian == '2' ?
                        <BadgeLarge
                            jihao={props.jihao}
                            hzsum={props.hzsum}/> :
                        null
                    }
                </div>

            </div>

            <div className={styles["bg-item"]} id='paiming'>
                <img className={styles.bg1} src={bg3}/>
                <img className={styles["img-pet2"]} src={pet3}/>
                <div className={styles["container-fengchao"]}>
                    <img className={styles["img-logo"]} src={logo}/>
                    <BarChart11
                        hzDzRankingData={props.hzDzRankingData}/>
                    <BarChart22/>
                </div>

            </div>

            <div className={styles["bg-item"]} id='hzdz'>
                <div className={styles["container-fengchao"]}>
                    <img className={styles["img-logo"]} src={logo}/>
                    <PieChart11/>
                    <PieChart22/>
                </div>
                <img className={styles.bg1} src={bg2}/>
                <img className={styles["img-pet1"]} src={pet2}/>

            </div>

            <div className={styles["bg-item"]} id='quxian'>
                <img className={styles.bg1} src={bg3}/>

                <div className={styles["container-fengchao"]}>
                    <div className={styles["text-blue"]}>学期表现曲线</div>
                    <LineChart11/>
                    <LineChart22/>
                </div>
                <img className={styles["img-pet2"]} src={pet4}/>
            </div>


            <div className={styles["bg-item"]} id='pingyu'>
                <img className={styles.bg1} src={bg2}/>

                <div className={styles["container-pingyu"]}>
                    <img className={styles["img-pingyu"]} src={ic_pingyu}/>
                    <div className={styles["div-pingyu"]}>{props.pingyu}</div>

                </div>
                <img className={styles["img-pet1"]} src={pet6}/>
            </div>


        </div>
    </div>

)

export default Studentinfo;
